export enum UploadFolder {
  ARTICLES = 'articles',
  DEFECTS = 'defects',
  ORDERARTICLES = 'orderArticles',
}
